import { ENV_TYPE } from '../../../../lib/constants'

export function getSubFlow(env) {
  const ENV_TO_SUB_FLOW_MAP = {
    [ENV_TYPE.SUMMARY]: 'send_again',
  }

  const subFlow = ENV_TO_SUB_FLOW_MAP[env]
  return subFlow || 'send_money'
}

export function getBooleanString(value) {
  if (value) {
    return 'y'
  }
  return 'n'
}
